<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-1-column--centered">
      <section class="grid-container-1-column__item">
        <q-card flat class="form-card" style="width:100%; max-width: 640px">
          <q-card-section class="form-card__section">
            <RequestPartnerAccess formType="Partner_Admin" /> </q-card-section
        ></q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import RequestPartnerAccess from "@/components/forms/RequestPartnerAccess.vue";
export default {
  name: "PartnerAdmin",
  components: {
    RequestPartnerAccess,
  },
};
</script>
